import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import "./style.scss";
import LanguageWhite from "../../assets/LanguageLight.svg";
import LanguageDark from "../../assets/LanguageDark.svg";
import Am from "../../assets/Armenia.svg";
import Ru from "../../assets/Russia.svg";
import US from "../../assets/US.svg";
import { sessionModel } from "entities/session";
import { useTranslation } from "react-i18next";
import { sircapApi } from "shared/api/sircap";

interface LanguageOption {
  code: string;
  labelKey: string;
  flagSrc: string;
  altText: string;
}
const LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: "am", labelKey: "Հայերեն", flagSrc: Am, altText: "Armenia" },
  { code: "ru", labelKey: "Русский", flagSrc: Ru, altText: "Russia" },
  { code: "en", labelKey: "English", flagSrc: US, altText: "English" },
];

type PropsType = {
  dark?: boolean;
};
export const ChangeLanguage: FC<PropsType> = ({ dark }) => {
  const { t, i18n } = useTranslation("onboarding-auth");
  const user = sessionModel.useCurrentUser();
  const [isOpened, setIsOpened] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (user?.language && user.language !== i18n.language) {
      i18n.changeLanguage(user.language);
      document.documentElement.setAttribute("lang", user.language);
    }
  }, [user?.language, i18n]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent | PointerEvent | TouchEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        setIsOpened(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside, true);
    document.addEventListener("pointerdown", handleClickOutside, true);
    document.addEventListener("touchstart", handleClickOutside, true);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
      document.removeEventListener("pointerdown", handleClickOutside, true);
      document.removeEventListener("touchstart", handleClickOutside, true);
    };
  }, []);

  const changeLanguage = useCallback(
    (language: string): void => {
      if (i18n.isInitialized && i18n.language !== language) {
        i18n.changeLanguage(language);
        sircapApi.changeLanguage(language);
        document.documentElement.setAttribute("lang", language);
      }
      setIsOpened(false);
    },
    [i18n]
  );

  return (
    <div ref={containerRef} className="change-language-for-layout">
      <button
        onClick={(e) => {
          e.stopPropagation();
          setIsOpened((prev) => !prev);
        }}
      >
        <img src={dark ? LanguageDark : LanguageWhite} alt="lang" />
      </button>

      {isOpened && (
        <ul className="language-dropdown-for-layout">
          {LANGUAGE_OPTIONS.map(({ code, labelKey, flagSrc, altText }) => (
            <li
              key={code}
              className={i18n.language === code ? "active" : ""}
              onClick={(e) => {
                e.stopPropagation();
                changeLanguage(code);
              }}
            >
              <img src={flagSrc} alt={altText} /> {labelKey}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
